export const trajectoryMap: Record<string, string> = {
  bounce: '原地上下弹跳',
  flash: '透明度闪烁',
  pulse: '原地缩放脉动',
  rubberBand: '横向拉伸回弹',
  shakeX: '水平左右抖动',
  shakeY: '垂直上下抖动',
  headShake: '左右摇头',
  swing: '顶部为轴摆动',
  tada: '缩放 + 左右旋',
  wobble: '左右摆动 + 倾斜',
  jello: '果冻式扭曲',
  heartBeat: '心跳式缩放',

  backInDown: '远→近 自上落入',
  backInLeft: '远→近 自左滑入',
  backInRight: '远→近 自右滑入',
  backInUp: '远→近 自下升入',

  backOutDown: '近→远 向下退出',
  backOutLeft: '近→远 向左退出',
  backOutRight: '近→远 向右退出',
  backOutUp: '近→远 向上退出',

  bounceIn: '中心弹跳放大',
  bounceInDown: '上→下 弹跳进入',
  bounceInLeft: '左→右 弹跳进入',
  bounceInRight: '右→左 弹跳进入',
  bounceInUp: '下→上 弹跳进入',

  bounceOut: '中心弹跳缩小',
  bounceOutDown: '弹跳向下退出',
  bounceOutLeft: '弹跳向左退出',
  bounceOutRight: '弹跳向右退出',
  bounceOutUp: '弹跳向上退出',

  fadeIn: '原地淡入',
  fadeInDown: '上→下 淡入',
  fadeInDownBig: '上→下 大幅淡入',
  fadeInLeft: '左→右 淡入',
  fadeInLeftBig: '左→右 大幅淡入',
  fadeInRight: '右→左 淡入',
  fadeInRightBig: '右→左 大幅淡入',
  fadeInUp: '下→上 淡入',
  fadeInUpBig: '下→上 大幅淡入',
  fadeInTopLeft: '左上→中 淡入',
  fadeInTopRight: '右上→中 淡入',
  fadeInBottomLeft: '左下→中 淡入',
  fadeInBottomRight: '右下→中 淡入',

  fadeOut: '原地淡出',
  fadeOutDown: '上→下 淡出',
  fadeOutDownBig: '上→下 大幅淡出',
  fadeOutLeft: '右→左 淡出',
  fadeOutLeftBig: '右→左 大幅淡出',
  fadeOutRight: '左→右 淡出',
  fadeOutRightBig: '左→右 大幅淡出',
  fadeOutUp: '下→上 淡出',
  fadeOutUpBig: '下→上 大幅淡出',
  fadeOutTopLeft: '中→左上 淡出',
  fadeOutTopRight: '中→右上 淡出',
  fadeOutBottomLeft: '中→左下 淡出',
  fadeOutBottomRight: '中→右下 淡出',

  flipInX: '横轴翻转进入',
  flipInY: '纵轴翻转进入',
  flipOutX: '横轴翻转退出',
  flipOutY: '纵轴翻转退出',

  lightSpeedInRight: '右→左 倾斜光速进入',
  lightSpeedInLeft: '左→右 倾斜光速进入',
  lightSpeedOutRight: '左→右 倾斜光速退出',
  lightSpeedOutLeft: '右→左 倾斜光速退出',

  rotateIn: '中心旋转进入',
  rotateInDownLeft: '左下为轴顺旋进入',
  rotateInDownRight: '右下为轴逆旋进入',
  rotateInUpLeft: '左下为轴逆旋进入',
  rotateInUpRight: '右下为轴顺旋进入',

  rotateOut: '中心旋转退出',
  rotateOutDownLeft: '左下为轴逆旋退出',
  rotateOutDownRight: '右下为轴顺旋退出',
  rotateOutUpLeft: '左下为轴顺旋退出',
  rotateOutUpRight: '右下为轴逆旋退出',

  hinge: '左上为轴坠落',
  jackInTheBox: '中心弹出 + 旋转',
  rollIn: '左→右 滚动进入',
  rollOut: '左→右 滚动退出',

  zoomIn: '中心放大进入',
  zoomInDown: '上→下 缩放进入',
  zoomInLeft: '左→右 缩放进入',
  zoomInRight: '右→左 缩放进入',
  zoomInUp: '下→上 缩放进入',

  zoomOut: '中心缩小退出',
  zoomOutDown: '上→下 缩放退出',
  zoomOutLeft: '左→右 缩放退出',
  zoomOutRight: '右→左 缩放退出',
  zoomOutUp: '下→上 缩放退出',

  slideInDown: '上→下 滑入',
  slideInLeft: '左→右 滑入',
  slideInRight: '右→左 滑入',
  slideInUp: '下→上 滑入',

  slideOutDown: '上→下 滑出',
  slideOutLeft: '右→左 滑出',
  slideOutRight: '左→右 滑出',
  slideOutUp: '下→上 滑出'
};
